export default {
  methods: {
    isMainDomain() {
      return window.location.host.includes("allefolders");
    }
  }
};
